import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  isCollapsed: boolean;
  isHidden: boolean;
}

interface SidebarActions {
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setSidebarHidden: (hidden: boolean) => void;
}

type SidebarStoreType = SidebarState & SidebarActions;

const useSidebarStore = create<SidebarStoreType>()(
  persist(
    (set) => ({
      isCollapsed: false,
      isHidden: false,
      toggleSidebar: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
      setSidebarCollapsed: (collapsed: boolean) => set({ isCollapsed: collapsed }),
      setSidebarHidden: (hidden: boolean) => set({ isHidden: hidden }),
    }),
    {
      name: 'sidebar-settings',
    }
  )
);

export default useSidebarStore;
